import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth';
import { useT } from '../i18n';

/** The warehouse's four screens: count the cooler, receive a delivery, pick the day's orders, the lots. */
export function StockNav() {
  const t = useT();
  const { me } = useAuth();
  // the prep card is printed by whoever runs the floor (decision 179)
  const prep = !!me && ['owner', 'office', 'warehouse'].includes(me.role);
  const links = [
    { to: '/stock', label: t('count'), end: true },
    { to: '/stock/receive', label: t('receive'), end: false },
    { to: '/stock/pick', label: t('pick'), end: false },
    ...(prep ? [{ to: '/stock/prep', label: t('prepTab'), end: false }] : []),
    { to: '/stock/lots', label: t('lots'), end: false },
    { to: '/stock/transfers', label: t('transfers'), end: false },
    { to: '/stock/scan', label: t('scan'), end: false },
    // the temperature log on the phone, where the floor and the drivers already are (decision 184)
    ...(me && ['owner', 'office', 'warehouse', 'driver'].includes(me.role) ? [{ to: '/compliance', label: t('tempTab'), end: false }] : []),
  ];
  return (
    <nav className="subnav" aria-label={t('stock')}>
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end}>
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
